import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';

//import TopNav from '../components/TopNav';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import MoimDetailHomePage from './MoimDetailHomePage';
import MoimDetailCommunityPage from './MoimDetailCommunityPage';
import { getBookcommunity } from '../api/BookcommunityApi';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';

const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 0 0 50px 0;
`;

const BannerImg = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 0;
  display: block;
`;


// 탭 스타일 (모임 메인화면과 동일)
const TabRow = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
`;

const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;


// 서평필사단 샘플 데이터
const reviewMoimDataList = [
  {
    banner: '/book_sample.jpg',
    profileImg: '',
    nickname: '띵북',
    userId: '@thingbook',
    badge: '모집자',
    tags: ['#고전', '#인문', '#화요일', '#동네책방', '#책인감'],
    bookDesc: '『가난의 문법』은 한국출판문화산업진흥원 2020 우수출판콘텐츠 선정작. 도시연구자 소준철이 2015년부터 2019년까지 연구한 결과를 책으로 묶었다. 저자는 재활용품을 수집하는 여성 도시 노인의 생애사적 특징과 재활용품 수집이라는 일을 통해 가난을 들여다본다.',
    book: {
      cover: '/book_sample.jpg',
      title: '가난의 문법',
      author: '소준철 / 푸른숲',
      모집기간: '2024.10.01까지',
      모집인원: '10명 (추첨)',
      서평기한: '2024.10.31까지',
    }
  },
  {
    banner: '/book_sample2.jpeg',
    profileImg: '',
    nickname: '띵북',
    userId: '@thingbook',
    badge: '모집자',
    tags: ['#인문', '#여행', '#Pensel', '#프랑스', '#파리'],
    bookDesc: '파리의 골목길을 걷는 듯한 감성 필사 모임.',
    book: {
      cover: '/book_sample2.jpeg',
      title: '패신저, 파리',
      author: '작가명 / 출판사',
      모집기간: '2024.10.10까지',
      모집인원: '20명 (추첨)',
      서평기한: '2024.10.30까지',
    }
  },
];

// 추천모임 샘플 데이터
const recommendMoimDataList = [
  {
    banner: '/book_sample6.jpeg',
    profileImg: '',
    nickname: '아침독서',
    userId: '@morning_reader',
    badge: '모임장',
    tags: ['#습관', '#아침', '#오프라인', '#독서', '#모임'],
    bookDesc: '매일 아침 7시, 오프라인 독서 습관 만들기. 함께 읽고 나누며 지속 가능한 독서 습관을 만들어갑니다.',
    book: {
      cover: '/book_sample6.jpeg',
      title: '아침독서모임',
      author: '독서모임 / 오프라인',
      모집기간: '상시모집',
      모집인원: '20명',
      회비: '월 10,000원',
    }
  },
  {
    banner: '/book_sample7.jpeg',
    profileImg: '',
    nickname: '퇴근필사',
    userId: '@evening_script',
    badge: '모임장',
    tags: ['#필사', '#퇴근', '#온라인', '#습관', '#마무리'],
    bookDesc: '퇴근 후 30분, 온라인 필사하며 하루 마무리. 바쁜 일상 속에서도 필사로 마음의 여유를 찾아보세요.',
    book: {
      cover: '/book_sample7.jpeg',
      title: '퇴근길 필사모임',
      author: '필사모임 / 온라인',
      모집기간: '상시모집',
      모집인원: '15명',
      회비: '무료',
    }
  },
  {
    banner: '/book_sample8.jpeg',
    profileImg: '',
    nickname: 'SF독서회',
    userId: '@sf_reader',
    badge: '모임장',
    tags: ['#SF', '#소설', '#장르', '#토론', '#오프라인'],
    bookDesc: '매주 토요일, 오프라인 SF소설 한 권 읽기. SF의 상상력을 함께 탐험해보세요.',
    book: {
      cover: '/book_sample8.jpeg',
      title: 'SF소설 읽기',
      author: 'SF독서회 / 오프라인',
      모집기간: '상시모집',
      모집인원: '12명',
      회비: '월 15,000원',
    }
  },
  {
    banner: '/book_sample9.jpeg',
    profileImg: '',
    nickname: '에세이러버',
    userId: '@essay_lover',
    badge: '모임장',
    tags: ['#에세이', '#감상', '#추천', '#온라인', '#나눔'],
    bookDesc: '에세이 추천과 감상 나누기 (온라인). 다양한 에세이를 통해 삶의 지혜를 나눕니다.',
    book: {
      cover: '/book_sample9.jpeg',
      title: '에세이 나눔',
      author: '에세이모임 / 온라인',
      모집기간: '상시모집',
      모집인원: '25명',
      회비: '무료',
    }
  },
  {
    banner: '/book_sample10.jpeg',
    profileImg: '',
    nickname: '클래식러버',
    userId: '@classic_lover',
    badge: '모임장',
    tags: ['#고전', '#문학', '#토론', '#오프라인', '#클래식'],
    bookDesc: '고전 문학 작품 함께 읽고 토론하기. 시대를 초월한 고전의 가치를 함께 탐구합니다.',
    book: {
      cover: '/book_sample10.jpeg',
      title: '클래식 독서회',
      author: '클래식독서회 / 오프라인',
      모집기간: '상시모집',
      모집인원: '18명',
      회비: '월 20,000원',
    }
  },
  {
    banner: '/book_sample11.jpeg',
    profileImg: '',
    nickname: '비즈니스북',
    userId: '@business_book',
    badge: '모임장',
    tags: ['#비즈니스', '#경영', '#인사이트', '#온라인', '#북클럽'],
    bookDesc: '경영/비즈니스 도서로 인사이트 공유. 실무에 도움이 되는 비즈니스 인사이트를 함께 나눕니다.',
    book: {
      cover: '/book_sample11.jpeg',
      title: '비즈니스 북클럽',
      author: '비즈니스북클럽 / 온라인',
      모집기간: '상시모집',
      모집인원: '30명',
      회비: '월 25,000원',
    }
  },
];


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function MoimDetailPage({bookCommunityId = null, onModified = null, onClose = null}) {
  const navigate = useNavigate();
  const query = useQuery();
  const tab = query.get('tab');
  const { setShowBack, setLogoText, showBack } = useNoobookContext();
  const [activeTab, setActiveTab] = useState(tab || 'home');
  const [bookcommunity, setBookcommunity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModified, setIsModified] = useState(false);
  const [selBookCommunityId, setSelBookCommunityId] = useState(bookCommunityId? bookCommunityId : query.get('bookCommunityId'));

  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(true);
    setLogoText('');
    return () => setShowBack(prevShowBack);
  }, [setShowBack, setLogoText]);


  useEffect(() => {
    loadBookcommunityData();
  }, [selBookCommunityId]);


  useEffect(() => {
    if(isModified) {
      loadBookcommunityData();
      if(onModified) {
        onModified(true);
      }
      setIsModified(false);
    }
  }, [isModified]);

  // title로 데이터 찾기 (서평필사단과 추천모임 모두에서 검색)
  //const moim = reviewMoimDataList[0];

  const loadBookcommunityData = async () => {
    if (!selBookCommunityId) {
      setError('모임 ID가 없습니다.');
      return;
    }
    if(loading) {
      return;
    }
    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      const response = await getBookcommunity(accessToken || '', selBookCommunityId);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setBookcommunity(processedResponse.data);
      } else {
        setError(processedResponse.errorMessage || '모임 정보를 불러오는데 실패했습니다.');
      }
    } catch (err) {
      console.error('모임 데이터 로드 중 오류:', err);
      setError('모임 정보를 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

 
  return (
    <Wrapper>
      <Content>
        <BannerImg src={bookcommunity?.imgUrl} alt="banner" />
        
        {/* 홈/커뮤니티 탭 */}
        <TabRow>
          <Tab active={activeTab==='home'} onClick={()=>setActiveTab('home')}>홈</Tab>
          <Tab active={activeTab==='community'} onClick={()=>setActiveTab('community')}>커뮤니티</Tab>
        </TabRow>
        {activeTab === 'home' && (
          <MoimDetailHomePage bookCommunity={bookcommunity}  bookCommunityId={selBookCommunityId} onModified={setIsModified} onDeleted={onClose} />
        )}
        
        {/* 커뮤니티 탭 내용 */}
        {activeTab === 'community' && (
          <MoimDetailCommunityPage bookCommunity={bookcommunity}  bookCommunityId={selBookCommunityId} onModified={setIsModified} />
        )}
      </Content>
    </Wrapper>
  );
  
} 